<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid pb-0">
      <!-- Page Header -->
      <div class="page-header mb-3">
        <div class="row align-items-center">
          <div class="col-md-4">
            <h3 class="page-title">Leads Dashboard</h3>
          </div>
          <div class="col-md-8 float-end ms-auto">
            <div class="d-flex title-head">
              <div class="view-icons">
                <a href="javascript:void(0);" class="grid-view btn btn-link"
                  ><i class="las la-redo-alt"></i
                ></a>
                <a
                  href="javascript:void(0);"
                  class="list-view btn btn-link"
                  id="collapse-header"
                  @click="toggleFullscreen"
                  ><i class="las la-expand-arrows-alt"></i
                ></a>
              </div>
              <div class="form-sort">
                <a href="javascript:void(0);" class="list-view btn btn-link"
                  ><i class="las la-file-export"></i>Export</a
                >
              </div>
              <div class="daterange-picker d-flex">
                <div class="form-sort">
                  <i class="las la-calendar"></i>
                  <input
                    type="text"
                    class="form-control date-range bookingrange"
                    ref="dateRangeInput"
                  />
                </div>
                <div class="form-sort">
                  <i class="las la-cubes"></i>
                  <vue-select
                    :options="LeadDash"
                    id="leaddash"
                    placeholder="Leads Dashboard"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <!-- /Page Header -->

      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="statistic-header">
                <h4>Lost Deals Stage</h4>
                <div class="dropdown statistic-dropdown">
                  <div class="card-select">
                    <ul>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Marketing Pipeline
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Marketing Pipeline
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Sales Pipeline
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item"> Email </a>
                          <a href="javascript:void(0);" class="dropdown-item"> Chats </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Operational
                          </a>
                        </div>
                      </li>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Last 3 months
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 3 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 6 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 12 months
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div id="last-chart"></div>
              <apexchart
                type="bar"
                height="150"
                :options="leads.leadscharts"
                :series="leads.series"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="statistic-header">
                <h4>Won Deals Stage</h4>
                <div class="dropdown statistic-dropdown">
                  <div class="card-select">
                    <ul>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Marketing Pipeline
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Marketing Pipeline
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Sales Pipeline
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item"> Email </a>
                          <a href="javascript:void(0);" class="dropdown-item"> Chats </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Operational
                          </a>
                        </div>
                      </li>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Last 3 months
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 3 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 6 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 12 months
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <apexchart
                type="bar"
                height="150"
                :options="leadsOne.leadschartsOne"
                :series="leadsOne.series"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="statistic-header">
                <h4>Deals by Year</h4>
                <div class="dropdown statistic-dropdown">
                  <div class="card-select">
                    <ul>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Last 3 months
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 3 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 6 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 12 months
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <apexchart
                type="line"
                height="350"
                :options="leadsTwo.leadschartsTwo"
                :series="leadsTwo.series"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="statistic-header">
                <h4>Leads By Stage</h4>
                <div class="dropdown statistic-dropdown">
                  <div class="card-select">
                    <ul>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Marketing Pipeline
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Marketing Pipeline
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Sales Pipeline
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item"> Email </a>
                          <a href="javascript:void(0);" class="dropdown-item"> Chats </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Operational
                          </a>
                        </div>
                      </li>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Last 3 months
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 3 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 6 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 12 months
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <apexchart
                type="pie"
                height="450"
                :options="leadsThree.leadschartsThree"
                :series="leadsThree.series"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="col-md-6 d-flex">
          <div class="card analytics-card w-100">
            <div class="card-body">
              <div class="statistic-header">
                <h4>Recently Created Leads</h4>
                <div class="dropdown statistic-dropdown">
                  <div class="card-select">
                    <ul>
                      <li>
                        <a
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="javascript:void(0);"
                        >
                          Last 3 months
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 3 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 6 months
                          </a>
                          <a href="javascript:void(0);" class="dropdown-item">
                            Last 12 months
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table custom-table table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>Deal Name</th>
                      <th>Company Name</th>
                      <th>Deal Value</th>
                      <th>Lead Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="record in Leads_Dashboard" :key="record.id">
                      <td><router-link to="/crm/deals-details">{{ record.DealName }}</router-link></td>
                      <td>
                        <h2 class="table-avatar d-flex">
                          <router-link to="/crm/company-details" class="avatar"
                            ><img
                              :src="require(`@/assets/img/company/${record.Image}`)"
                              alt="User Image"
                          /></router-link>
                          <router-link
                            to="/crm/company-details"
                            class="profile-split d-flex flex-column"
                            >{{ record.CompanyName
                            }}<span>{{ record.Location }}</span></router-link
                          >
                        </h2>
                      </td>
                      <td>{{ record.DealValue }}</td>
                      <td>
                        <span :class="record.Class">{{ record.LeadStatus }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
  </div>
</template>
<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref } from "vue";
import { onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import Leads_Dashboard from "@/assets/json/leads-dashboard.json";
import { leads, leadsOne, leadsTwo, leadsThree } from "./data";
export default {
  data() {
    return {
      leads: leads,
      leadsOne: leadsOne,
      leadsTwo: leadsTwo,
      leadsThree: leadsThree,
      Leads_Dashboard: Leads_Dashboard,
      LeadDash: ["Leads Dashboard", "Deals Dashboard"],
    };
  },
  setup() {
    const dateRangeInput = ref(null);
    onMounted(() => {
      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();

        function booking_range(start, end) {
          // Function declaration moved to the root level of the function body
          function formatDate(date) {
            return date.format("M/D/YYYY");
          }
          return formatDate(start) + " - " + formatDate(end);
        }

        new DateRangePicker(
          dateRangeInput.value,
          {
            startDate: start,
            endDate: end,
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [moment().startOf("month"), moment().endOf("month")],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
            },
          },
          booking_range
        );

        booking_range(start, end);
      }
    });
    return {
      dateRangeInput,
    };
  },
  methods: {
    toggleFullscreen() {
      const elem = document.documentElement;
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
    },
  },
};
</script>
